import { styled } from 'styled-components';

import { spacing } from '#/theme/theme';

export const PageFooterLocaleLinksHolder = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[24]};

  > *:not(:first-child) {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: -12px;
      height: 16px;
      width: 1px;
      background: currentcolor;
      pointer-events: none;
    }
  }
`;
